module.exports = __webpack_public_path__ + "img/bloqs4_CHAT.f2e91034.svg";